import { fetchData } from "@/services/backend";

export default [
  {
    path: "/ofertas",
    component: () => import("@/views/ofertas/Listar.vue"),
  },
  {
    path: "/ofertas/analisis-productividad-comercial",
    component: () => import("@/views/ofertas/AnalisisComercial/productividad/AnalisisProductividadComercial.vue"),
  },
  {
    path: "/ofertas/analisis-pronostico-comercial",
    component: () => import("@/views/ofertas/AnalisisComercial/pronostico/AnalisisPronosticoComercial.vue"),
  },
  {
    path: "/ofertas/analisis-por-modulos",
    component: () => import("@/views/ofertas/AnalisisComercial/modulos/AnalisisPorModulos.vue"),
  },
  {
    path: "/ofertas/versiones/:id",
    component: () => import("@/views/ofertas/ListarVersiones.vue"),
  },
  {
    path: "/ofertas/crear",
    component: () => import("@/views/ofertas/Crear.vue"),
  },
  {
    path: "/ofertas/editar/:id",
    component: () => import("@/views/ofertas/Editar.vue"),
  },
  {
    path: "/ofertas/editarContenido/:id",
    component: () => import("@/views/ofertas/EditarContenido.vue"),
  },
  {
    path: "/ofertas/editarContenidoModulos/:id",
    component: () => import("@/views/ofertas/EditarContenidoModulos.vue"),
  },
  {
    path: "/ofertas/editarContrato/:id",
    component: () => import("@/views/ofertas/EditarContrato.vue"),
  },
  {
    path: "/ofertas/ganar/:id",
    component: () => import("@/views/ofertas/GanarOferta.vue"),
  },
  {
    path: "/ofertas/perder/:id",
    component: () => import("@/views/ofertas/PerderOferta.vue"),
  },
  {
    path: "/motivosCierreOferta",
    component: () => import("@/views/motivosCierreOferta/Listar.vue"),
  },
  {
    path: "/motivosCierreOferta/crear",
    component: () => import("@/views/motivosCierreOferta/Crear.vue"),
  },
  {
    path: "/motivosCierreOferta/editar/:id",
    component: () => import("@/views/motivosCierreOferta/Editar.vue"),
  },
];
